import React from 'react';
import { Grid, CardContent, Typography, makeStyles, Button } from '@material-ui/core';
import { useDevice } from 'components/DeviceContext.js';
import figuraMenino from 'imagens/desenho-criancas.png'

const useStyles = makeStyles({
    root: {
        margin: '20px ',
        width: '20%',
        textAlign: 'center',
        '@media (max-width: 2000px)': {
            height: '40%',
            width: '20%',
        },
        '@media (max-width: 768px)': {
            height: '80%',
            width: '100%',
        },
        '@media (max-width: 480px)': {
            height: '35%',
            width: '35%',
        },

    },

    cardImage: {
        width: '46%',

    },
    title: {
        fontSize: '1em'
    },


    largeCard: {
        margin: '20px',
        width: '50%',
        textAlign: 'center',
        height: '60%',
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
        '@media (max-width: 1440px)': {
            height: '70%',
            width: '50%',

        },
        '@media (max-width: 800px)': {
            height: '90%',
            width: '50%',
        },
        '@media (max-width: 480px)': {
            height: '90%',
            width: '100%',
        },


    },
});
const cardsData = [
    { title: '', content: <span style={{ fontWeight: 'bold', fontSize: '1.4em' }}>Prefeito(a), você sabia que pode captar recurso para aumentar a sua receita e financiar projetos sociais para crianças e adolescentes do seu Município?</span>, border: '2px solid var(--azul)', backgroundColor: 'var(--azul)', image: '', color: 'var(--branco)', },
    { title: <span style={{ fontWeight: 'bold', margin: '1em  '}}>Criação do FIA</span>, content: '', image: require('imagens/imgCards/icon-criacao.png'), border: '2px solid var(--laranja)', color: 'var(--laranja)', link: './criacao-do-fia', padding: ' 1em 0 1em 0' },
    { title: <span style={{ fontWeight: 'bold' }}>Cenário</span>, content: 'Municipal', image: require('imagens/imgCards/icon-cenario.png'), border: '2px solid var(--laranja)', color: 'var(--laranja)', link: '/cenario-municipal' },
    { title: 'Instrumentos de', content: <span style={{ fontWeight: 'bold' }}>Planejamento</span>, border: '2px solid var(--azul)', image: require('imagens/imgCards/icon-planejamento.png'), color: 'var(--azul)', link: './instrumentos-de-planejamento' },
    { title: 'Potencial de', content: <span style={{ fontWeight: 'bold' }}>Arrecadação</span>, image: require('imagens/imgCards/icon-arrecadacao.png'), border: '2px solid var(--laranja)', color: 'var(--laranja)', link: '/potencial-de-arrecadacao' },
];

const Cards = () => {
    const classes = useStyles();
    const { isMobile, isTablet, isLaptop, isDesktop } = useDevice();

    return (
        <Grid container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '3rem' }}>

            <img src={figuraMenino} alt="figura menino" style={{ width:isTablet ? '18%' :  isLaptop ? '20%' : '13%', position: 'absolute', marginRight: isTablet ? '80%' :  isLaptop ? '54%' : isDesktop ? '36%' : '', display: isMobile ? 'none' : '' }} />
            <Grid style={{ display: 'flex', width: isMobile || isTablet ? '100%' : isLaptop ? '65%' : '50%', justifyContent: isDesktop || isLaptop ? 'end' : 'center', flexWrap: 'wrap', alignItems: 'end' }}>
                {cardsData.map((card, index) => (
                    <a key={index} href={card.link} className={index === 0 ? classes.largeCard : classes.root} style={{ backgroundColor: card.backgroundColor, borderRadius: '20px', alignItems: 'center', color: card.color, border: card.border, fontSize: isMobile ? '14px' : '', fontWeight: card.fontWeight, padding: card.padding }}>
                        <CardContent className={classes.cardContent}>
                            <img src={card.image} alt={card.title} className={classes.cardImage} />
                            <Typography className={classes.title} gutterBottom>
                                {card.title}
                            </Typography>
                            <Typography  >
                                {card.content}
                            </Typography>
                        </CardContent>
                        {index === 0 && (
                            <Grid style={{ backgroundColor: 'var(--branco)', padding: '1em' }}>
                                <a href="/saiba-mais">
                                    <Button variant="contained" style={{ backgroundColor: 'var(--laranja)', borderRadius: '1em', color: 'var(--branco)', padding: '0.5em 2.5em' }} >
                                        Saiba Mais
                                    </Button>
                                </a>
                            </Grid>
                        )}
                    </a>
                ))}
            </Grid>


        </Grid>
    );
};

export default Cards;
